const consentGoogleTagManager = (allowed: boolean) => {
	if (typeof window === "undefined") return

	const windowObj = window as any
	windowObj.dataLayer = windowObj.dataLayer || []
	// gtag consent update requires the arguments-style push that GTM recognises
	function gtag(..._args: unknown[]) {
		// eslint-disable-next-line prefer-rest-params
		windowObj.dataLayer.push(arguments)
	}
	gtag("consent", "update", {
		ad_storage: allowed ? "granted" : "denied",
		ad_user_data: allowed ? "granted" : "denied",
		ad_personalization: allowed ? "granted" : "denied",
		analytics_storage: allowed ? "granted" : "denied",
	})
}

export default consentGoogleTagManager
